import template from "./error_message.html";

const errorMessageComponent = {
  bindings: { message: "<" },
  template
};

export default errorMessageComponent;
